import { TASK_LIST_TYPE, TASK_LIST_DISPLAY_NAME, SHOW_TITLE_PROPERTY } from './taskListConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: TASK_LIST_TYPE,
        content: {
            title: null,
            [SHOW_TITLE_PROPERTY]: false,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: TASK_LIST_TYPE,
        objectConstructorFn,
        displayName: TASK_LIST_DISPLAY_NAME,
        ...params,
    });
